(() => {
  if (window.MulticolumnSliderSection) return;

  class MulticolumnSliderSection {
    constructor(section) {
      if (!section) return;

      this.section = section;

      this.initSliders();
    }

    initSliders() {
      this.section
        .querySelectorAll('[data-multicolumn-slider]')
        .forEach((container) => {
          if (container.dataset.initialized === 'true') return;

          container.dataset.initialized = 'true';

          this.buildSwiper(container);
        });
    }

    buildSwiper(container) {
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded.');
        return;
      }

      const loop = container.dataset.loop === 'true';

      const autoplayEnabled =
        container.dataset.autoplay === 'true';

      const autoplayTime =
        parseInt(
          container.dataset.autoplayTime || 0,
          10
        ) * 1000;

      const showNavigation =
        container.dataset.navigation === 'true';

      const desktopSlides =
        parseFloat(
          container.dataset.slidePerView || 3
        );

      const mobileSlides =
        parseFloat(
          container.dataset.mSlidePerView || 1
        );

      const spaceBetween =
        parseInt(
          container.dataset.spaceBetween || 10,
          10
        );

      const mobileSpaceBetween =
        parseInt(
          container.dataset.mSpaceBetween || spaceBetween,
          10
        );

      const navigation = showNavigation
        ? {
            nextEl: container.querySelector(
              '.swiper-button-next'
            ),

            prevEl: container.querySelector(
              '.swiper-button-prev'
            ),
          }
        : false;

      const autoplay = autoplayEnabled
        ? {
            delay: autoplayTime,

            disableOnInteraction: false,

            pauseOnMouseEnter: true,
          }
        : false;

      const swiper = new Swiper(container, {
        loop: loop,

        slidesPerView: mobileSlides,

        spaceBetween: mobileSpaceBetween,

        navigation: navigation,

        autoplay: autoplay,

        observer: true,

        observeParents: true,

        watchOverflow: true,

        grabCursor: true,

        speed: 500,

        breakpoints: {
          750: {
            slidesPerView: 3,

            spaceBetween: mobileSpaceBetween,
          },

          1024: {
            slidesPerView: desktopSlides,

            spaceBetween: spaceBetween,
          },
        },
      });

      container.swiper = swiper;

      const images =
        container.querySelectorAll('img');

      images.forEach((image) => {
        if (!image.complete) {
          image.addEventListener(
            'load',
            () => {
              swiper.update();
            },
            {
              once: true,
            }
          );
        }
      });
    }
  }


  window.MulticolumnSliderSection =
    MulticolumnSliderSection;

  const init = () => {
    document
      .querySelectorAll(
        '.shopify-section .multicolumn'
      )
      .forEach((section) => {
        if (
          section.querySelector(
            '[data-multicolumn-slider]'
          )
        ) {
          new MulticolumnSliderSection(section);
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '.multicolumn'
            )
          : null;

      if (section) {
        new MulticolumnSliderSection(section);
      }
    }
  );

  document.addEventListener(
    'shopify:section:reorder',
    () => {
      init();
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const slide =
        event.target.closest(
          '.swiper-slide'
        );

      if (!slide) return;

      const container =
        slide.closest(
          '[data-multicolumn-slider]'
        );

      if (
        container &&
        container.swiper
      ) {
        const index =
          Array.from(
            container.querySelectorAll(
              '.swiper-slide'
            )
          ).indexOf(slide);

        if (index >= 0) {
          container.swiper.slideTo(index);
        }
      }
    }
  );
})();
